const get = state => state.sideFiltersData;

export const getSideFiltersSelector = state => state.filtersReducer.sideFilters;
export const getSelectedSideFiltersSelector = state => get(state).selectedSideFilters;
export const getCurrentFilterPageSelector = state => get(state).currentPageName;
export const getAppliedSideFiltersSelector = state => get(state).appliedSideFilters;
export const getSideFilterSectionUiSelector = state => get(state).sideFiltersSectionUi;

export const getTopFiltersSelector = state => state.filtersReducer.topFilters;
